import { createFileRoute, redirect } from '@tanstack/react-router'
import { optionalSession } from '~/features/auth/queries'
import { SetupWizard } from '~/features/setup/SetupWizard'

export const Route = createFileRoute('/setup')({
  beforeLoad: async ({ context }) => {
    const session = await optionalSession((q) => context.queryClient.ensureQueryData(q))
    if (!session) throw redirect({ to: '/login', search: { from: '/setup' } })
  },
  component: SetupWizard,
})
